import React from 'react'
import { Table, Tooltip } from 'antd'
import { UserSwitchOutlined } from '@ant-design/icons'
import _ from 'lodash'
import axios from 'axios'
import { injectIntl } from 'react-intl'
import { showErrorMessage } from 'services/handleErrors'
import endpoints from 'services/endpoints'
import { parseLocalTime } from 'services/utils'
import { ConditionalWrapper } from 'services/ConditionalWrapper'
import classnames from 'classnames'
import { Amount } from 'components/Amount'
import financeIconSprite from 'assets/img/finance/sprite.svg'

import style from './style.module.scss'

const stateMap = {
  active: {
    title: 'components.commissions-modal.status.active',
    iconId: 'status_waiting',
  },
  rejected: {
    title: 'components.commissions-modal.status.rejected',
    iconId: 'status_canceled',
  },
  paid_out: {
    title: 'components.commissions-modal.status.paid_out',
    iconId: 'status_approved',
  },
}

class Commissions extends React.Component {
  state = {
    page: 1,
    limit: 10,
    total: 0,
    commissions: [],
    loading: false,
  }

  componentDidMount() {
    this.getCommissions()
  }

  getCommissions = () => {
    this.setState({ loading: true })
    const { filter } = this.props
    const { page, limit } = this.state

    axios
      .post(endpoints.getCommissions, { ...filter, page, limit })
      .then(({ data }) =>
        this.setState({
          commissions: _.get(data, 'commissions', []),
          total: parseInt(_.get(data, 'total', 0), 10),
          loading: false,
        }),
      )
      .catch(err => {
        this.setState({ loading: false })
        showErrorMessage(err)
      })
  }

  handleTableChange = pagination => this.setState({ page: pagination.current, limit: pagination.pageSize }, this.getCommissions)

  render() {
    const { formatMessage } = this.props.intl

    const columns = [
      {
        title: formatMessage({ id: 'components.commissions-modal.table.user' }),
        dataIndex: 'payment',
        key: 'user',
        render: payment => {
          if (payment.user) {
            const { firstname, lastname, login } = payment.user

            return (
              <Tooltip title={`@${login}`}>{`${firstname || ''} ${lastname || ''}`}</Tooltip>
            )
          }

          if (payment.externalUser) {
            return (
              // "Пользователь не участвует в партнерской программе"
              <Tooltip title={formatMessage({ id: 'components.commissions-modal.table.user.external' })}>
                {payment.externalUser.fullname}&nbsp;&nbsp;<UserSwitchOutlined />
              </Tooltip>
            )
          }

          return null
        },
      },
      {
        title: formatMessage({ id: 'components.commissions-modal.table.level' }),
        dataIndex: 'level',
        key: 'level',
        render: level => level || 0,
      },
      {
        title: formatMessage({ id: 'components.commissions-modal.table.date' }),
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: createdAt => parseLocalTime(createdAt),
      },
      {
        title: formatMessage({ id: 'components.commissions-modal.table.product' }),
        dataIndex: 'payment',
        key: 'product',
        render: payment => _.get(payment, 'product.title', ''),
      },
      {
        title: formatMessage({ id: 'components.commissions-modal.table.commission' }),
        dataIndex: 'commission',
        key: 'commission',
        render: commission => <Amount value={commission} currencyCode="rur" />,
      },
      {
        title: formatMessage({ id: 'components.commissions-modal.table.percent' }),
        dataIndex: 'percent',
        key: 'percent',
        render: percent => <>{percent || 0}%</>,
      },
      {
        title: formatMessage({ id: 'components.commissions-modal.table.amount' }),
        dataIndex: 'amount',
        key: 'amount',
        render: amount => (
          <ConditionalWrapper
            condition={amount}
            wrapper={child => (
              <span className={classnames(style.amount, { [style.subtract]: amount < 0 })}>
                {child}
              </span>
            )}
          >
            <Amount value={amount} currencyCode="rur" />
          </ConditionalWrapper>
        ),
      },
      {
        title: formatMessage({ id: 'components.commissions-modal.table.status' }),
        dataIndex: 'state',
        key: 'state',
        className: style.stateCol,
        render: state => {
          const title = stateMap[state] ? formatMessage({ id: stateMap[state].title }) : ''
          let iconId = null

          if (stateMap[state] && stateMap[state].iconId) {
            // eslint-disable-next-line prefer-destructuring
            iconId = stateMap[state].iconId
          }

          return (
            <Tooltip title={title}>
              <svg className={style.icon}>
                <use href={`${financeIconSprite}#${iconId}`} />
              </svg>
            </Tooltip>
          )
        },
      },
    ]

    const preparedData = this.state.commissions.map(commission => ({
      ...commission,
      key: commission.id,
    }))

    return (
      <Table
        className={style.commissions}
        loading={this.state.loading}
        columns={columns}
        dataSource={preparedData}
        pagination={{
          pageSize: this.state.limit,
          total: this.state.total,
          current: this.state.page,
        }}
        onChange={this.handleTableChange}
      />
    )
  }
}

export default injectIntl(Commissions)
